import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Dialog, DialogContent, DialogTitle, Grid, Paper, Slide } from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";

import { savePresupuesto, setActiveStep, updatePresupuestoValues } from "../../../actions/autorizaciones/Autorizaciones";

import {
  STEPPER_AUTORIZACIONES,
  TIPOS_AUTORIZACIONES,
} from "../../../utils/constants";

import { AutorizacionesAccordionDiagnostico } from "./Accordions/AutorizacionesAccordionDiagnostico";
import { AutorizacionesAccordionDocumentacion } from "./Accordions/AutorizacionesAccordionDocumentacion";

import {
  postSolicitud,
  setShowForm,
} from "../../../actions/autorizaciones/Autorizaciones";
import { startAlerta } from "../../../actions/ui/alertas";
import { AutorizacionesAccordionDocumentacionPresupuesto } from "./Accordions/AutorizacionesAccordionDocumentacionPresupuesto";
import { NotasMenu } from "../gestionAuditoria/Menus/NotasMenu";
import Notes from "../UI/Notes";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const AutorizacionesDetalleOrdenInformation = (props) => {
  const dispatch = useDispatch();

  const { solicitudSeleccionada, presupuestoSeleccionado } = useSelector(
    (state) => state.autorizaciones
  );

  const [datosCompletosDiagnostico, setDatosCompletosDiagnostico] = useState(false);
  const [datosCompletosDocumentacion, setDatosCompletosDocumentacion] = useState(false);
  const [showModalNotas, setShowModalNotas] = useState(false);

  const submitHandler = () => {

    if (
      datosCompletosDiagnostico &&
      (datosCompletosDocumentacion ||
        props.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION)
    ) {

      if (props.idTipoSolicitud !== TIPOS_AUTORIZACIONES.PRESUPUESTOS) {
        dispatch(postSolicitud(solicitudSeleccionada));
      }
      else {
        dispatch(savePresupuesto(presupuestoSeleccionado));
      }

      if (props.idTipoSolicitud === TIPOS_AUTORIZACIONES.ESTADIAS ||
        props.idTipoSolicitud === TIPOS_AUTORIZACIONES.PASAJES) {
        dispatch(setActiveStep(STEPPER_AUTORIZACIONES.CONFIRMACION));
      } else {
        dispatch(setActiveStep(STEPPER_AUTORIZACIONES.PRACTICAS));
      }
    } else {
      dispatch(
        startAlerta(
          `Debe completar ${datosCompletosDiagnostico ? "la documentación." : "el diagnostico."
          }`,
          "error",
          "Error"
        )
      );
    }
  };

  return (
    <React.Fragment>
      {showModalNotas && (
        <Dialog
          open={showModalNotas}
          onClose={() => setShowModalNotas(false)}
          fullWidth
          maxWidth="sm"
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle>Notas</DialogTitle>
          <DialogContent>
            <NotasMenu showBotonAgregar={false} desdeIngresoSolicitud={true} />
          </DialogContent>
        </Dialog>
      )}
      {(props.idTipoSolicitud === TIPOS_AUTORIZACIONES.PASAJES || props.idTipoSolicitud === TIPOS_AUTORIZACIONES.ESTADIAS)
        &&
        <Grid
          container
          spacing={2}
          style={{ display: "flex", justifyContent: "center", marginLeft: '15rem' }}
        >
          <Notes
            onClick={() => { setShowModalNotas(true) }}
          />
        </Grid>
      }
      <ValidatorForm onSubmit={submitHandler}>
        <div style={{ marginTop: props.idTipoSolicitud === TIPOS_AUTORIZACIONES.PASAJES || props.idTipoSolicitud === TIPOS_AUTORIZACIONES.ESTADIAS ? '2rem' : '0rem' }}> {/* Agregamos margen superior aquí */}
          <AutorizacionesAccordionDiagnostico
            datosCompletos={datosCompletosDiagnostico}
            setDatosCompletos={setDatosCompletosDiagnostico}
            idTipoSolicitud={props.idTipoSolicitud}
          />
        </div>
        {props.idTipoSolicitud !==
          TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION && (
            props.idTipoSolicitud ===
              TIPOS_AUTORIZACIONES.PRESUPUESTOS
              ?
              <AutorizacionesAccordionDocumentacionPresupuesto
                datosCompletos={datosCompletosDocumentacion}
                setDatosCompletos={setDatosCompletosDocumentacion}
              />
              :
              <AutorizacionesAccordionDocumentacion
                datosCompletos={datosCompletosDocumentacion}
                setDatosCompletos={setDatosCompletosDocumentacion}
                ingresoLaboCab={solicitudSeleccionada?.idTipoSolicitud 
                  === TIPOS_AUTORIZACIONES.LABORATORIO
                }
              />
          )}
        {props.idTipoSolicitud ===
          TIPOS_AUTORIZACIONES.PRESUPUESTOS &&
          <Paper style={{ padding: 15 }}>
            <TextValidator
              style={{ marginTop: "1rem", /* marginLeft: "1rem" */ }}
              label="Observación"
              name="observacion"
              fullWidth
              inputProps={{ maxLength: 140 }}
              onChange={e => {
                dispatch(
                  updatePresupuestoValues({
                    observacion: e.target.value
                  })
                );
              }}
              value={presupuestoSeleccionado?.observacion}
            />
          </Paper>
        }
        <div
          style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{ marginRight: "3rem" }}
            onClick={() => {
              dispatch(setShowForm(true));
            }}
          >
            Anterior
          </Button>
          <Button variant="contained" color="primary" type="submit">
            Siguiente
          </Button>
        </div>
      </ValidatorForm>
    </React.Fragment>
  );
};
